module.exports = __webpack_public_path__ + "img/RS.4c8a706a.svg";